import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { AppComponent } from '../../../app.component';
import { Router } from '@angular/router';
import { SeguridadService } from '../../../services/seguridad.service';
import { ConceptoService } from 'src/app/services/tesoreria/concepto.service';
import { Concepto } from 'src/app/models/tesoreria/concepto.model';
import { Global } from 'src/global';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { HomeService } from 'src/app/services/home.service';
import { MessageService } from 'primeng/api';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Rendicion } from 'src/app/models/tesoreria/rendicion.model';
import { ProcesoReporte } from '../../base/proceso-reporte';
import { RendicionService } from 'src/app/services/tesoreria/rendicion.service';
import { GrupoAcceso, GrupoAccesoRegistro } from 'src/app/models/seguridad/grupo_acceso.model';
import { ReporteService } from 'src/app/services/reporte.service';
import { RendicionCaja } from 'src/app/models/tesoreria/rendicion_caja.model';
import { Empresa } from 'src/app/models/configuracion/empresa.model';
import { MenuService } from 'src/app/services/menu.service';

@Component({
  selector: 'app-dashboard1',
  templateUrl: './dashboard1.component.html',
  styleUrls: ['./dashboard1.component.scss']
})
export class Dashboard1Component extends ProcesoReporte implements OnInit {

    tipoNormal = Empresa.NORMAL;
    tipoInversionista = Empresa.INVERSIONISTA;
    tipoCooperativa = Empresa.COOPERATIVA;

    cantidad: string;

    crearRendicion: boolean = false;
    isMobileView: boolean;
    tipoAcceso: number = GrupoAccesoRegistro.ACCESO_USUARIO;

    ingresos: Record<string, any>[] = [];
    egresos: Record<string, any>[] = [];
    otrosValores: Record<string, any>[] = [];
    totalIngreso: number = 0;
    totalEgreso: number = 0;
    totalOtrosValores: number = 0;

    showDialogRendicion: boolean = false;
    fgRendicion: FormGroup;
    conceptoSelected: Record<string, any>;
    rendicionCajas: Record<string, any>;
    mostrarErrorConcepto: boolean = false;
    fromDate: Date ;
    toDate: Date ;
    // variables para el grafico
    meses: string [] = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    labels: string [];
    ordersChart: any;
    ordersOptions: any;
    totalDesembolso: number;
    totalCobro: number;
    desembolsoMesActual: number;
    cobroMesActual: number;
    mostrarMenuCajero: boolean;
    @ViewChild("input") elm;
    grupoAcceso: GrupoAcceso;
    saludo: string;
    usuario: string;
    seguridad: boolean;
    configuracion: boolean;
    tesoreria: boolean;
    tarjeta: boolean;
    contabilidad: boolean;
    prestamo: boolean;
    prestamo_solidario: boolean;
    notificacion: boolean;
    crm: boolean;
    menu: Record<string, any>[];
    mostrarVentana: boolean;
    nombreVentana: string;
    procesos: Record<string,any>;
    reportes: Record<string,any>;
    registros: Record<string,any>[];
    constructor( 
        public app: AppComponent, 
        private breadcrumbService: AppBreadcrumbService,
        private router: Router,
        private seguridadService: SeguridadService,
        private homeService: HomeService,
        private datePipe: DatePipe,
        private currencyPipe: CurrencyPipe,
        private messageService: MessageService,
        private conceptoService: ConceptoService,
        private rendicionService: RendicionService,
        private reporteService: ReporteService,
        private cdr: ChangeDetectorRef,
        private menuService: MenuService,
        private fb: FormBuilder,
    ) {
        super();
        this.breadcrumbService.setItems([ { label: 'Dashboard' } ]);
        this.formGroup = this.fb.group({
            id_empresa: [this.currentUser?.id_empresa]
        });
        this.fromDate = new Date();
        this.toDate = new Date();
        this.totalCobro = 0;
        this.totalDesembolso = 0;
        this.cobroMesActual = 0;
        this.desembolsoMesActual = 0;
        this.mostrarMenuCajero = false;
        this.usuario = this.currentUser.nombre;   
        this.configuracion = false;
        this.seguridad = false;
        this.tesoreria = false;
        this.tarjeta = false;
        this.contabilidad = false;
        this.prestamo = false;
        this.prestamo_solidario = false;
        this.notificacion = false;
        this.crm = false;
        this.nombreVentana = '';  
        this.registros = [];
        this.menu = [];
        this.procesos = [];
        this.registros = [];
    }

    ngOnInit(): void {
        this.initHome();
        this.detectDevice();
    }

    setFocus() {
        this.elm.input.nativeElement.focus();
    }
    
    detectDevice(): void {
        const userAgent = window.navigator.userAgent.toLowerCase();
        this.isMobileView = userAgent.includes('mobile') || userAgent.includes('tablet');
    }

    @HostListener('window:resize', ['$event'])
    onWindowResize(event: any): void {
        this.detectDevice();
    }

    async buscar() {
        this.initHome();
    }

    async initHome() {
        await this.checkPermisos();
        await this.cargarConceptos();
        await this.rendicionCajadelDia();
        await this.initDashboard();
        await this.getMenu();
        if ( this.currentUser.empresa.tipo === this.tipoCooperativa ) {
            // await this.cargarCantidades();
            // await this.graficoMedalla();
            this.router.navigate(['pages','home','grafico'])
        }
    }

    async cerrarCaja() {
        this.router.navigate(['pages','tesoreria','rendiciones-caja','nuevo']);
    }

    async onNavigate( routerLink: String[] ) {
        this.router.navigate(routerLink);
    }


    async checkPermisos() {
        this.grupoAcceso = new GrupoAcceso();
        await this.grupoAcceso.cargarObjeto(this.currentUser.grupo_acceso);
        if ( this.currentUser.grupo_acceso.acceso_total ) {
            this.configuracion = true;
            this.tesoreria = true;
            this.tarjeta = true;
            this.contabilidad = true;
            this.seguridad = true;
            this.prestamo = true;
            this.prestamo_solidario = true;
            this.mostrarMenuCajero = true;
            this.notificacion = true;
            this.crm = true;
        } else {
            const permisoCajero = this.grupoAcceso.permisos?.find( (item) => item.codigo === GrupoAcceso.MENU_RENDICION_CAJA);       
            if (permisoCajero?.activo) {
                this.mostrarMenuCajero = true;
            }        
            for (let index = 0; index < this.grupoAcceso.modulos.length; index++) {
                const acceso = this.grupoAcceso.modulos[index];            
                switch (acceso.codigo) {
                    case 'configuracion':
                        this.configuracion = acceso.activo;
                        break;
                    case 'tesoreria':
                        this.tesoreria = acceso.activo;
                        break;
                    case 'prestamo':
                        this.prestamo = acceso.activo;
                        break;
                    case 'prestamo_solidario':
                        this.prestamo_solidario = acceso.activo;
                        break;
                    case 'contabilidad':
                        this.contabilidad = acceso.activo;
                        break;    
                    case 'seguridad':
                        this.seguridad = acceso.activo;
                        break;
                    case 'notificacion':
                        this.notificacion = acceso.activo;
                        break;
                    case 'crm':
                        this.crm = acceso.activo;
                        break;
                    case 'cliente_tarjeta':
                        this.tarjeta = acceso.activo;
                        break;
                    default:
                        break;
                }
            }
        }        
        this.crearRendicion = await this.seguridadService.puedeCrear(Rendicion.CODIGO_MODULO, Rendicion.CODIGO_REGISTRO);
        this.tipoAcceso = await this.seguridadService.tipoAcceso(Rendicion.CODIGO_MODULO, Rendicion.CODIGO_REGISTRO);
    }

    async getMenu() {
        this.menu = await this.menuService.getMenu();        
    }

    async accesos(codigo: any) { // solo trae los reportes, procesos y registros 
        this.nombreVentana = '';
        this.registros = [];
        this.reportes = null;
        this.procesos = null;
        const menu = this.menu.find((menu) => menu.codigo === codigo )        
        for (let index = 0; index < menu.items.length; index++) {
            const item = menu.items[index];
            if ( item.label === 'Reportes' ){
                this.reportes = item;
            }else if ( item.label === 'Procesos'){
                this.procesos = item;
            } else {
                this.registros.push(item)
            }
        }
        this.nombreVentana = menu.label;
        this.mostrarVentana = true;
    }  

    async cajero() {
        this.router.navigate(['pages','tesoreria','procesos','cajero']);
    }

    async grafico() {
        this.router.navigate(['pages','home','grafico']);
    }

    async cargarConceptos() {        
        try {
            const filtros = {
                nivel: Concepto.NIVEL_PRINCIPAL,
                uso: Concepto.USO_CAJA,
                id_empresa: this.currentUser.id_empresa,
                fecha_desde: this.datePipe.transform(this.fromDate, 'yyyy-MM-dd'),
                fecha_hasta: this.datePipe.transform(this.toDate, 'yyyy-MM-dd'),
                // is_rendicion_caja: true
            }

            if ( this.tipoAcceso === GrupoAccesoRegistro.ACCESO_USUARIO ) { filtros['id_creado_por'] = this.currentUser.id };

            const resp = await this.homeService.rendicionesPorConcepto(filtros);
            if ( !resp.ok ) { throw new Error(`${resp.msg} - ${resp.resp}`) };
            this.ingresos = resp.resp.filter( c => c.tipo === Concepto.INGRESO );
            this.egresos = resp.resp.filter( c => c.tipo === Concepto.EGRESO );
            this.otrosValores = resp.resp.filter( c => c.tipo === Concepto.VALORES );
            this.totalIngreso = this.ingresos.reduce( (accumulator, currentValue) => { return (accumulator + currentValue.monto)}, 0 );
            this.totalEgreso = this.egresos.reduce( (accumulator, currentValue) => { return (accumulator + currentValue.monto)}, 0 );
            this.totalOtrosValores = this.otrosValores.reduce( (accumulator, currentValue) => { return (accumulator + currentValue.monto)}, 0 );
                    
        } catch (error) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        }
    }


    /** Fuciones de Modal Rendicion */
    async onListaConcepto() {
        const filtros = await this.getFiltroEmpresa();
        const value = this.fgRendicion.value;
        filtros.push({ field: 'id_concepto_principal', type: 'id', value: value.id_concepto_principal });
        filtros.push({ field: 'nivel', type: 'numeric', value: Concepto.NIVEL_SECUNDARIO });
        await super.onLista(this.conceptoService, Concepto, 'Conceptos', filtros);
    }

    async onConcepto() {
        try {
            const value = this.fgRendicion.value;
            let concepto = null
            if ( value.id_concepto_principal && value.codigo_concepto_secundario ) {
                const filtros = await this.getFiltroEmpresa();
                filtros.push({ field: 'codigo', type: 'unique', value: value.codigo_concepto_secundario });
                filtros.push({ field: 'id_concepto_principal', type: 'id', value: value.id_concepto_principal });
                filtros.push({ field: 'nivel', type: 'numeric', value: Concepto.NIVEL_SECUNDARIO });
                const res = await this.conceptoService.getAll(Global.SIZE_GET_ALL, { filters: filtros });
                if ( res.ok && res.resp.rows ) {
                    concepto = res.resp.rows[0];
                } else {
                    this.messageService.add({severity: 'error', summary: res.msg, detail: res.resp});
                }
            }
            await this.setConcepto(concepto);
        } catch (error: any) {
            this.messageService.add(this.objSession);
            setTimeout( () => { this.router.navigate(this.routerLogout) }, 4000);
        }
    }

    async cerrarOnLista( obj?: Record<string, any> ): Promise<void> {
        await super.cerrarOnLista( obj );
        if ( this.objClassOnLista === Concepto && obj ) { await this.setConcepto(obj) };
        this.objClassOnLista = null;
    }

    async setConcepto( obj: Record<string, any> ) {
        this.fgRendicion.get('codigo_concepto_secundario').setValue(obj?.codigo ? obj.codigo : null);
        this.fgRendicion.get('nombre_concepto_secundario').setValue(obj?.nombre ? obj.nombre : null);
        this.mostrarErrorConcepto = false;
    }
    
    async nuevaRendicion( item: Record<string, any> ) {        
        if (await this.seguridadService.puedeCrear(Rendicion.CODIGO_MODULO ,Rendicion.CODIGO_REGISTRO )) {
            this.conceptoSelected = item;
            const rendicion = new Rendicion();
            rendicion.idConceptoPrincipal = item.id;
            rendicion.codigoConceptoPrincipal = item.codigo;
            rendicion.nombreConceptoPrincipal = item.nombre;
            this.fgRendicion = await rendicion.getFormGroup();
            this.showDialogRendicion = true;
        }
    }

    async cancelarRendicion() {
        this.fgRendicion = null;
        this.showDialogRendicion = false;
        this.conceptoSelected = null;
    }

    async confirmarRendicion() {
        if ( this.fgRendicion.invalid ) {
            await this.setInvalidControlsDetalle( this.fgRendicion );
            this.messageService.add({severity: 'error', summary: 'Formulario Inválido', detail: 'Complete los campos obligatorios'});
            return;
        }
        if ( this.fgRendicion.value.monto === 0 ) {
            this.messageService.add({severity: 'error', summary: 'Formulario Inválido', detail: 'Monto no puede ser 0 (Cero)'});
            return;
        }
        if ( this.conceptoSelected.obligar_concepto_secundario && !this.fgRendicion.value.codigo_concepto_secundario ) {
            this.messageService.add({severity: 'error', summary: 'Formulario Inválido', detail: 'Seleccione un Concepto'});
            this.mostrarErrorConcepto = true;
            return;
        }
        this.fgRendicion.get('aprobado').setValue(true);
        const resp = await this.rendicionService.post(this.fgRendicion.value);
        this.showDialogRendicion = false;
        this.conceptoSelected = null;
        await this.cargarConceptos();
        this.cdr.detectChanges();
    }

    async rendicionCajadelDia( ) {
        try {
            const filtros = {
                id_empresa: this.currentUser.id_empresa,
                fecha_desde: this.datePipe.transform(this.fromDate, 'yyyy-MM-dd'),
                fecha_hasta: this.datePipe.transform(this.toDate, 'yyyy-MM-dd')
            }                
            if ( this.tipoAcceso === GrupoAccesoRegistro.ACCESO_USUARIO ) { filtros['id_creado_por'] = this.currentUser.id };
            const res = await this.homeService.rendicionCajadelDia(filtros);
            if ( res.ok  ) {
                this.rendicionCajas = res.resp;
                this.cantidad = this.rendicionCajas[0].cantidad;                
            } else {
                this.messageService.add({severity: 'error', summary: res.msg, detail: res.resp});
            }
            
        } catch (error: any) {            
            this.messageService.add(this.objSession);
            // setTimeout( () => { this.router.navigate(this.routerLogout) }, 4000);
        }

    }

    async informeRendicionesCaja() {
        if (await this.seguridadService.puedeEjecutar( RendicionCaja.CODIGO_MODULO, GrupoAcceso.LISTADO_RENDICION_CAJA )) {
            const filtros = { 
                fecha_desde: this.fromDate,
                fecha_hasta: this.toDate,       
            }                            
            this.reporteService.setFiltroStorage('listado_rendicion_caja', filtros);
            this.router.navigate([this.prefixPage, 'tesoreria','reportes', 'listado-rendicion-caja']);
        }
    }

    async informeRendiciones( item: Record<string, any>) {        
        if ( item.monto > 0 ) {
            if (await this.seguridadService.puedeEjecutar( Rendicion.CODIGO_MODULO, GrupoAcceso.LISTADO_RENDICION )) {
                const filtros = { 
                    fecha_desde: this.fromDate, 
                    fecha_hasta: this.toDate,           
                    id_concepto_principal: item.id,
                    codigo_concepto_principal: item.codigo,
                    nombre_concepto_principal: item.nombre,
                }                            
                this.reporteService.setFiltroStorage('listado_rendicion', filtros);
                this.router.navigate([this.prefixPage, 'tesoreria','reportes', 'listado-rendicion']);
            }
        }
    }

    async initDashboard() {
        try {
            const resp = await this.homeService.getMontoPrestamo({
                usuario: JSON.parse(JSON.stringify(this.currentUser)),
                id_empresa: this.currentUser.id_empresa,
                fecha_desde: this.datePipe.transform(this.fromDate, 'yyyy-MM-dd'),
                fecha_hasta: this.datePipe.transform(this.toDate, 'yyyy-MM-dd')
            });
            await this.calculos(resp.resp);

            if (resp.ok) {
                const date = new Date();
                const mesActual = date.getMonth() + 1;

                this.labels = this.generateLabels(mesActual);

                const { maxDesembolsado, dataDesembolso, dataCobrado, saldo } = this.processChartData(resp.resp, mesActual);

                this.ordersChart = this.createChartConfig(dataDesembolso, dataCobrado, saldo);
                this.ordersOptions = this.getOrdersOptions( maxDesembolsado);
            }
        } catch (error) {
            this.messageService.add(this.objSession);
            setTimeout(() => { this.router.navigate(this.routerLogout) }, 4000);
        }
    }

    generateLabels(mesActual: number): string[] {
        const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        const labels: string[] = [];
        
        for (let i = 1; i <= mesActual; i++) {
            labels.push(meses[i - 1]);
        }

        return labels;
    }

    processChartData(data: any[], mesActual: number): {  maxDesembolsado: number, dataDesembolso: number[], dataCobrado: number[], saldo: number[] } {
        let maxDesembolsado = 0;
        const dataDesembolso = [];
        const dataCobrado = [];
        const saldo = [];

        for (let i = 1; i <= mesActual; i++) {
            const matchingDato = data.find(dato => dato.mes === i);

            if (matchingDato) {
                dataDesembolso.push(matchingDato.desembolso);
                saldo.push(matchingDato.saldo);
                dataCobrado.push(matchingDato.cobro);
                if (matchingDato.desembolso > maxDesembolsado) { maxDesembolsado = matchingDato.desembolso };
            } else {
                dataCobrado.push(0);
                dataDesembolso.push(0);
                saldo.push(0);
            }
        }

        return {  maxDesembolsado, dataDesembolso, dataCobrado, saldo };
    }

    createChartConfig(dataDesembolso: number[], dataCobrado: number[], saldo: number[]): any {
        
        return {
            labels: this.labels,
            datasets: [
            {
                yAxisID: 'y1',
                type: 'bar',
                label: 'Desembolso',
                data: dataDesembolso,
                borderColor: ['#06b59e'],
                backgroundColor: ['#24f1c8'],
                borderWidth: 2,
                fill: true,
                tension: .4,
                barThickness: 50, 
                borderSkipped: false, 
                shadowOffsetX: 2,
                shadowOffsetY: 2,
                shadowBlur: 4,
                shadowColor: 'rgba(63, 81, 181, 0.4)'
                
            },
            { 
                yAxisID: 'y1',
                type: 'bar',
                label: 'Cobranza',
                data: dataCobrado,
                borderColor: [' #4dd60d'],
                backgroundColor: ['#a3ff33'],
                borderWidth: 2,
                fill: true,
                tension: .4,
                barThickness: 50,
                borderSkipped: false,
                shadowOffsetX: 2,
                shadowOffsetY: 2,
                shadowBlur: 4,
                // shadowColor: 'rgba(255, 128, 0, 0.4)'
            },  {
                yAxisID: 'y',
                label: 'Saldo',
                data: saldo,
                borderColor: ['rgba(248, 207, 32)'],
                backgroundColor: ['rgba(248, 207, 32, 0.6)'],
                borderWidth: 2,
                fill: true,
                tension: .4,
                barThickness: 50,
                borderSkipped: false,
                shadowOffsetX: 2,
                shadowOffsetY: 2,
                shadowBlur: 4,
            }],
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
        };
    }

    getOrdersOptions( maxDesembolsado: number): any {
        const textColor = getComputedStyle(document.body).getPropertyValue('--text-color') || 'rgba(0, 0, 0, 0.87)';
        const gridLinesColor = getComputedStyle(document.body).getPropertyValue('--divider-color') || 'rgba(160, 167, 181, .3)';
        const fontFamily = getComputedStyle(document.body).getPropertyValue('--font-family');

        return {
            plugins: {
                datalabels: {
                    anchor: 'center',
                    clamp: true,
                    rotation: 0,

                    align: 'end',
                    formatter: (value: any, ctx: any) => {
                        return this.currencyPipe.transform(value, '', '', '0.0-0', 'es-PY');
                    },
                    color: '#000000',
                    font: { size: 11, weight: 'bold' }
                },
                legend: { labels: { fontFamily, color: textColor } }
            },
            responsive: true,
            scales: {
                y: {
                    position: 'right', // Cambiado a 'right' para colocar el máximo desembolsado a la izquierda
                    display: true,
                    ticks: { fontFamily, color: textColor },
                    grid: { color: gridLinesColor, max: maxDesembolsado + 10 } // Ajusta el valor máximo del eje y según tus necesidades
                },
                y1: {
                    position: 'left',
                    display: true,
                    ticks: { fontFamily, color: textColor },
                    grid: { color: gridLinesColor },
                    maxRotation: 45, // Ajusta el ángulo de rotación de las etiquetas para el eje y1
                    minRotation: 0 // Ángulo mínimo de rotación
                },
                x: { ticks: { fontFamily, color: textColor }, grid: { color: gridLinesColor } }
            },elements: {
                bar: {
                    backgroundColor: {
                        // Usa un gradiente lineal
                        linear: {
                            // Dirección del gradiente
                            orientation: 'bottom'
                        }
                    }
                }
            },
            onClick: (e, data, a) => {
                const idx = data[0]?.index
                let fecha_desde = new Date();
                let fecha_hasta = new Date();
                // Ipcion MES
                    if ( idx >= 0 ) {
                        fecha_desde = new Date(fecha_desde.getFullYear(), idx , 1)
                        fecha_hasta = new Date(fecha_hasta.getFullYear(), idx + 1, 0)
                        const filtros = { 
                            id_empresa: this.currentUser.id_empresa,
                            fecha_desde: fecha_desde,
                            fecha_hasta: fecha_hasta
                        }                        
                
                        this.reporteService.setFiltroStorage('seguimiento_prestamo', filtros);
                        this.router.navigate([this.prefixPage, 'prestamo_solidario','reportes','seguimiento-prestamo']);
                    }
                } 
                
            
        };
    }


    async calculos(resp: any) {
        const date = new Date();
        const mesActual = date.getMonth() + 1;
        const datoMesActual = resp.find(dato => dato.mes === mesActual);
        if (datoMesActual) {
            this.desembolsoMesActual = datoMesActual.desembolso;
            this.cobroMesActual = datoMesActual.cobro;
        }
        this.totalDesembolso = resp.reduce((total, item) => total + item.desembolso, 0);
        this.totalCobro = resp.reduce((total, item) => total + item.cobro, 0);
    }

}
